import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import 'antd/dist/reset.css';
import AdminLayout from './components/AdminLayout';
import Login from './components/Login';
import ProtectedRoute from './components/ProtectedRoute';
import { isAuthenticated } from './utils/helpers';

function App() {
  return (
    <div className="App">
      <Routes>
        <Route 
          path="/login" 
          element={
            isAuthenticated() ? 
            <Navigate to="/" replace /> : 
            <Login />
          } 
        />
        <Route 
          path="*" 
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </div>
  );
}

export default App;
